import { render, staticRenderFns } from "./SleProductsAdmin.vue?vue&type=template&id=c5f976dc&"
import script from "./SleProductsAdmin.vue?vue&type=script&lang=js&"
export * from "./SleProductsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SleProductsAdmin.vue?vue&type=style&index=0&id=c5f976dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports